import { getNationalPhoneNumber } from "@msidentity/SISU/model/alias/phone-number";
import { type SmsActionType, ChannelType } from "@msidentity/SISU/model/proof";
import { type MemberNameTypeValues, MemberNameType } from "@msidentity/SISU/model/user";
import { type ICountryInfo } from "@msidentity/SISU/utilities/country-helper";
import { type SendOttRequest } from "../../../utilities/api-helpers";

/**
 * Gets the sendOtt parameters
 * @param sendOttAction The action to send the OTT
 * @param inputType The type of the input (Should only be Phone or EASI)
 * @param phoneCountry The country of the phone
 * @param inputVal The input value
 * @returns The sendOtt parameters
 */
export function getSendOttParams(
  sendOttAction: SmsActionType,
  inputType: MemberNameType | MemberNameTypeValues,
  phoneCountry: ICountryInfo,
  inputVal: string,
): SendOttRequest {
  const inputValueTrimmed = inputVal.trim();
  const isPhoneProof = inputType !== MemberNameType.EASI;

  return {
    action: sendOttAction,
    isPhoneProof,
    proofCountryIso: isPhoneProof ? phoneCountry.iso : undefined,
    channel: isPhoneProof ? ChannelType.SMS : ChannelType.Email,
    proofId: isPhoneProof
      ? getNationalPhoneNumber(inputValueTrimmed, phoneCountry.code)
      : inputValueTrimmed,
  };
}
